import { formatUnderscoreToSpace } from "../../utils/text-format";

export const TextView = ({ label, value }) => {
  return (
    <div className="my-4">
      <label className="text-sm font-semibold text-gray-800 capitalize">
        {formatUnderscoreToSpace(label)}
      </label>
      <div className="my-1">{value ?? "--"}</div>
    </div>
  );
};

export const TextViewArray = ({ label, value = [] }) => {
  return (
    <div className="my-4">
      <label className="text-sm font-semibold text-gray-800 capitalize">
        {formatUnderscoreToSpace(label)}
      </label>
      <div className="my-1">
        {value?.map((ele, index) => {
          return (
            <span key={index}>
              <span className="text-greyText">{index ? " | " : ""}</span>
              {ele ? ele : "--"}
            </span>
          );
        })}
      </div>
    </div>
  );
};
export const EditorTextView = ({ label, value }) => {
  return (
    <div className="my-4">
      <label className="text-sm font-semibold text-gray-800 capitalize">
        {formatUnderscoreToSpace(label)}
      </label>
      <div
        className="my-1 prose max-w-none"
        dangerouslySetInnerHTML={{ __html: value || "--" }}
      />
    </div>
  );
};
